import React from "react";
import DataTable from "components/DataTable/DataTable";
import { useMyAccessRequestColumns } from "./functions/useMyAccessRequestColumns";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";
import { IAccessRequestEntity } from "models/AccessRequest.model";
import { useTranslation } from "react-i18next";

type Props = {
  data: IAccessRequestEntity[];
  onClickOpenApplication: (accessRequestGuid: string, applicationId: number) => void;
  onClickRequestAccess: (applicationId: number) => void;
};

const MyAccessRequestTable: React.FC<Props> = ({ data, onClickOpenApplication, onClickRequestAccess }) => {
  const { t } = useTranslation();
  const columns = useMyAccessRequestColumns({
    onClickOpenApplication,
    onClickRequestAccess,
  });

  return (
    <StyledDataTable
      data-testid={"MyAccessRequestTable"}
      data={data}
      columns={columns}
      sortById={"description"}
      sortDesc={true}
      tableLayout={"fixed"}
      verticalAlign={"top"}
      noResultFoundText={t("No access requests")}
    />
  );
};

const StyledDataTable = styled(DataTable)(
  ({ theme }) => css`
    border: 0;

    table > thead > tr > th,
    table > tbody > tr > td {
      border-right: 0;
      vertical-align: middle;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  `
);

export default MyAccessRequestTable;
